import { render, staticRenderFns } from "./PopupMedicalView.vue?vue&type=template&id=6236954a&"
import script from "./PopupMedicalView.vue?vue&type=script&lang=js&"
export * from "./PopupMedicalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev-002\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6236954a')) {
      api.createRecord('6236954a', component.options)
    } else {
      api.reload('6236954a', component.options)
    }
    module.hot.accept("./PopupMedicalView.vue?vue&type=template&id=6236954a&", function () {
      api.rerender('6236954a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dashboard/popup/PopupMedicalView.vue"
export default component.exports